import _ from 'lodash';
import Location from './namespaces/location';
import Site from './namespaces/site';
import Window from './namespaces/window';

import monitoring from './privates/monitoring';

const namespaces = {
    Location,
    Site,
    Window
};

export default _.mapValues(namespaces, (namespace) => monitoring.monitorNamespace(namespace));
